<template>
    <div class="construction-page">
        <h1>🚧 الموقع تحت الانشاء 🚧</h1>
        <img src="@/assets/images/under_construction.png" alt="Under Construction" />
    </div>
</template>

<script>
export default {
    name: "UnderConstruction",
};
</script>

<style scoped>
.construction-page {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    text-align: center;
    background-color: #f4f4f4;
    color: #333;
}

img {
    max-width: 300px;
    height: auto;
    margin-top: 20px;
}
</style>
